module.exports = __webpack_public_path__ + "zvetseni-prsou_58_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_58_after.jpg
// module id = 1351
// module chunks = 0